import { Box, Button, Chip, Skeleton, Typography } from "@mui/material";
import {
  API_URL,
  BootstrapTooltip,
  ConvertToShamsiDate,
  handleCopy,
  handleSendMessage,
} from "../../utilities";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";
import PopoverComponent from "../../components/PopoverComponent";
import NewFollowupSchedule from "./new-followup-schedule";
import SkeltonProgress from "../../components/SkeltonProgress";
import { IAppUser } from "src/interface/IUser";
import { TypeUser } from "src/interface/enum/TypeUser";
import renderCellExpand from "src/GridComponents/GridExpand";
import { ListOfFollowUpType } from "src/interface/enum/FollowUpType";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
import { IFollowupSchedule } from "src/interface/IFollowupSchedule";
import { IAgreement } from "src/interface/IAgreement";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import {
  ListOfStatusGlobal,
  StatusGlobal,
} from "src/interface/enum/StatusGlobal";
import LanguageIcon from "@mui/icons-material/Language";
import PasswordIcon from "@mui/icons-material/Password";
import KeyIcon from "@mui/icons-material/Key";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { ISystem } from "src/interface/ISystem";
import { getRoutes } from "src/utilities/routes";

const FollowupsScheduleList = ({
  followupType,
  error,
  rows,
  refetch,
  setRows,
  isLoading,
}: {
  followupType: "Agreement" | "Customer";
  error: any;
  rows: IFollowupSchedule[];
  setRows: (rows: IFollowupSchedule[]) => void;
  isLoading: boolean;
  refetch: any;
}) => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const [openActionForm, setOpenActionForm] = useState<boolean>(false);
  useEffect(() => {
    if (error) {
      handleSendMessage(
        notifications,
        "خطا در دریافت اطلاعات" + error.toString(),
        "error"
      );

      console.log(error);
    }
  }, [error]);

  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columns: GridColDef[] = [
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 230,
      getActions: (params) => [
        <BootstrapTooltip title="مدیریت پیگیری ها">
          <GridActionsCellItem
            icon={<ManageHistoryIcon color="primary" />}
            label="مدیریت پیگیری ها"
            className="textPrimary"
            onClick={handleEditClick(params.id)}
            color="inherit"
          />
        </BootstrapTooltip>,
        <BootstrapTooltip title="حذف">
          <GridActionsCellItem
            icon={<DeleteIcon color="error" />}
            label="حذف"
            onClick={(event) => handleDeleteClick(event, params.row)}
            color="inherit"
          />
        </BootstrapTooltip>,
        <BootstrapTooltip title="سامانه">
          <GridActionsCellItem
            icon={<LanguageIcon color="secondary" />}
            label="سامانه"
            //TODO درست کردن اونت این  باتن سامانه ها
            onClick={() =>
              handleOpenSystem(params.row.appUserWebSystem.systemRef)
            }
            color="inherit"
          />
        </BootstrapTooltip>,
        <BootstrapTooltip title="کپی نام کاربری">
          <GridActionsCellItem
            icon={<KeyIcon color="primary" />}
            label="کپی نام کاربری"
            onClick={(event) =>
              handleCopy(params.row.appUserWebSystem.userName, notifications)
            }
            color="inherit"
          />
        </BootstrapTooltip>,
        <BootstrapTooltip title="کپی پسورد">
          <GridActionsCellItem
            icon={<PasswordIcon color="primary" />}
            label="کپی پسورد"
            onClick={() =>
              handleCopy(params.row.appUserWebSystem.password, notifications)
            }
            color="inherit"
          />
        </BootstrapTooltip>,
        <BootstrapTooltip title="کارت های بانکی">
          <GridActionsCellItem
            icon={<CreditCardIcon color="success" />}
            label="کارت های بانکی"
            //TODO درست کردن اونت این  باتن کارت های بانکی ها
            //onClick={(event) => handleDeleteClick(event, params.row)}
            color="inherit"
          />
        </BootstrapTooltip>,
      ],
    },
    {
      field: "customerName",
      headerName: "نام مشتری",
      align: "left",
      headerAlign: "left",
      editable: false,
      sortable: true,
      minWidth: 200,
      renderCell: (params: GridRenderCellParams<any, string>) => {
        return (
          <Typography style={{ whiteSpace: "pre-line" }}>
            {params.value}
          </Typography>
        );
      },
    },

    {
      field: "creatorName",
      headerName: "نام کارمند",
      align: "left",
      headerAlign: "left",
      editable: false,
      sortable: true,
      minWidth: 150,
      renderCell: (params: GridRenderCellParams<any, string>) => {
        return (
          <Typography style={{ whiteSpace: "pre-line" }}>
            {params.value}
          </Typography>
        );
      },
    },

    {
      field: "title",
      headerName: "عنوان",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 180,
    },
    {
      field: "lastTaskLog",
      headerName: "وضعیت",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      // type: "singleSelect",
      // valueOptions: ListOfStatusGlobal,
      renderCell: (params) => (
        <Chip
          label={
            ListOfStatusGlobal.find(
              (g) =>
                g.value ===
                (params.value
                  ? params.value?.statusTask
                  : StatusGlobal.NotStarted)
            )?.label
          }
          //@ts-ignore
          color={
            ListOfStatusGlobal.find(
              (g) =>
                g.value ===
                (params.value
                  ? params.value?.statusTask
                  : StatusGlobal.NotStarted)
            )?.color
          }
          variant="filled"
        />
      ),
      minWidth: 150,
    },
    {
      field: "startedOn",
      headerName: "تاریخ شروع",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 200,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "endedOn",
      headerName: "تاریخ پایان",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 200,
    },
    {
      field: "followUpType",
      headerName: "نوع پیگیری",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "singleSelect",
      valueOptions: ListOfFollowUpType,
      minWidth: 150,
    },
    {
      field: "period",
      headerName: "دوره",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "number",
      minWidth: 100,
    },
    {
      field: "isActive",
      headerName: "فعال",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "boolean",
      minWidth: 130,
    },
    {
      field: "isSMS",
      headerName: "پیامک",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "boolean",
      minWidth: 130,
    },
    {
      field: "desc",
      headerName: "توضیحات",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 250,
      valueGetter: (value: any, row: any) => {
        // ترکیب توضیحات اصلی و توضیحات فرزند برای جستجو
        const mainDesc = value || "";
        const childDesc = row.childDesc || "";
        return `${mainDesc} ${childDesc}`.trim();
      },
      renderCell: renderCellExpand,
    },
    {
      field: "createdOn",
      headerName: "تاریخ ثبت",
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "modifiedOn",
      minWidth: 150,
      headerName: "آخرین تغییرات",
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
  ];

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async (followupScheduleId: string) => {
      const url = API_URL + "followup-schedule/" + followupScheduleId;
      const hasToken = !!user?.token;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      const body = await response.json().catch(() => ({}));
      return { body, httpStatus: response.status };
    },
    onError: (error) => {
      handleSendMessage(
        notifications,
        "خطا در دریافت اطلاعات" + error,
        "error"
      );
    },
  });

  const [followupSchedule, setFollowupSchedule] = useState<IFollowupSchedule>();

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    followup: IFollowupSchedule
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setFollowupSchedule(followup);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    const id = followupSchedule?.id?.toString() || "";
    try {
      const { body: res, httpStatus } = await deleteAsync(id);
      const removedFromGrid = () => {
        setRows(rows.filter((r: IFollowupSchedule) => r.id?.toString() !== id));
      };
      if (httpStatus === 200 && res?.status) {
        handleSendMessage(notifications, "حذف با موفقیت انجام شد!", "success");
        setFollowupSchedule(undefined);
        removedFromGrid();
        await refetch();
      } else if (httpStatus === 404 || res?.data?.includes?.("پیدا نشد")) {
        handleSendMessage(notifications, "رکورد قبلاً حذف شده است.", "info");
        removedFromGrid();
        await refetch();
      } else {
        handleSendMessage(notifications, "خطا در حذف! " + (res?.data ?? ""), "error");
      }
    } catch (error) {
      handleSendMessage(
        notifications,
        "خطا در دریافت اطلاعات" + error,
        "error"
      );
    } finally {
      refetch();
      handleDeletePopoverClose();
    }
  };
  const { mutateAsync: GetSystemById } = useMutation({
    mutationFn: async (systemId: string) => {
      const response = await fetch(API_URL + "systems/" + systemId, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      handleSendMessage(
        notifications,
        "خطا در دریافت اطلاعات" + error,
        "error"
      );
      console.log(error);
    },
  });

  const handleOpenSystem = async (systemRef: string) => {
    const system: ISystem = await GetSystemById(systemRef);
    if (system && system.url) {
      window.open(system.url, "_blank");
    } else {
      handleSendMessage(notifications, "خطا در باز کردن لینک سیستم", "error");
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenActionForm(true)}
        >
          پیگیری جدید
        </Button>
      </GridToolbarContainer>
    );
  }

  const [followupId, setFollowupId] = useState<number>();
  const handleEditClick = (id: GridRowId) => () => {
    setFollowupId(id as number);
    setOpenActionForm(true);
  };

  const handleClose = () => {
    setOpenActionForm(false);
  };
  return (
    <>
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />

      <NewFollowupSchedule
        open={openActionForm}
        handleClose={handleClose}
        refetch={refetch}
        isEdit={!!followupId}
        followupId={followupId}
        setFollowupId={setFollowupId}
        // data={rowInfo}
      />

      <Box
        sx={{
          width: {
            xs: 370, // عرض برای اندازه‌های کوچک
            sm: 500, // عرض برای اندازه‌های متوسط
            md: 720, // عرض برای اندازه‌های بزرگ
            lg: "calc(100% - 80px)", // عرض برای اندازه‌های خیلی بزرگ
            xl: "calc(100% - 80px)", // عرض برای اندازه‌های فوق‌العاده بزرگ
          },
        }}
      >
        {isLoading ? (
          <SkeltonProgress />
        ) : (
          <GridViewMUIX
            gridUniqueName={"FollowupsScheduleList" + followupType}
            columns={columns}
            loading={isLoading}
            EditToolbar={EditToolbar}
            rowModesModel={rowModesModel}
            sortFields={{ field: "modifiedOn", sort: "desc" }}
            rows={
              followupType === "Agreement"
                ? rows
                    ?.filter((r: IFollowupSchedule) => r.agreementRef !== null)
                    .map((row) => ({
                      ...row,
                      customerName: row.customer
                        ? `${row.customer.fName} ${row.customer.lName}${row.customer.coName ? `\n${row.customer.coName}` : ""}`
                        : "",
                      creatorName: row.creator
                        ? `${row.creator.fName} ${row.creator.lName}`
                        : "",
                    }))
                : rows
                    ?.filter((r: IFollowupSchedule) => r.agreementRef === null)
                    .map((row) => ({
                      ...row,
                      customerName: row.customer
                        ? `${row.customer.fName} ${row.customer.lName}${row.customer.coName ? `\n${row.customer.coName}` : ""}`
                        : "",
                      creatorName: row.creator
                        ? `${row.creator.fName} ${row.creator.lName}`
                        : "",
                    }))
            }
            setRowModesModel={setRowModesModel}
          />
        )}
      </Box>
    </>
  );
};

export default FollowupsScheduleList;
